import { Button, Box, Typography } from '@mui/material';
import { useRef } from 'react';
import { convertTimeTo12HourFormat, useNextAppointment } from '@shared-components/hooks/useNextAppointment/useNextAppointment';
import useResetFocusOnBfcacheRestore from '@shared-components/hooks/useResetFocusOnBfcacheRestore/useResetFocusOnBfcacheRestore';
type AccordionPAOProps = {
  type?: 'sick';
  title?: string;
};
function capitalizeFirstLetter(string: string | null | undefined): string {
  if (!string) return '';
  return string.charAt(0).toUpperCase() + string.slice(1);
}
const AccordionPAO: React.FC<AccordionPAOProps> = ({
  type = 'sick',
  title = 'Sick pet'
}: AccordionPAOProps) => {
  const {
    officeInfo,
    siteUrl,
    appointment,
    scheduleText
  } = useNextAppointment(type);
  const buttonsRef = useRef<HTMLDivElement>(null);
  useResetFocusOnBfcacheRestore(buttonsRef);
  if (!officeInfo) {
    return null;
  }
  return <Box sx={{
    mt: 2
  }} data-sentry-element="Box" data-sentry-component="AccordionPAO" data-sentry-source-file="AccordionPAO.tsx">
			<Typography component="p" variant="bodyMediumSemiBold" color="text.secondary" sx={{
      mb: 0.5
    }} data-sentry-element="Typography" data-sentry-source-file="AccordionPAO.tsx">
				{title} exam appointments at{' '}
				<Typography variant="bodyMediumSemiBold" color="text.primary" data-sentry-element="Typography" data-sentry-source-file="AccordionPAO.tsx">
					{capitalizeFirstLetter(officeInfo?.brand?.toLowerCase())} - {officeInfo?.name}
				</Typography>
			</Typography>
			<Typography component="p" variant="bodySmallBook" sx={{
      color: 'text.tertiary'
    }} data-sentry-element="Typography" data-sentry-source-file="AccordionPAO.tsx">
				{officeInfo.address?.address1}
			</Typography>
			<Typography variant="bodySmallBook" sx={{
      color: 'text.tertiary'
    }} data-sentry-element="Typography" data-sentry-source-file="AccordionPAO.tsx">
				{officeInfo.address?.city}, {officeInfo.address?.stateCode} {officeInfo.address?.zipCode}
			</Typography>
			<Box ref={buttonsRef} sx={{
      display: 'flex',
      gap: 1,
      flexWrap: 'wrap'
    }} mt={2} data-sentry-element="Box" data-sentry-source-file="AccordionPAO.tsx">
				{appointment ? <>
						<Button size="M" variant="primaryDefault" data-testid="button_schedule_today" href={`${siteUrl}/book-an-appointment/?fc=${officeInfo.code}&visitReason=${type}&timeSlot=${appointment?.date}T${appointment?.time}`}>
							Schedule {scheduleText} at {convertTimeTo12HourFormat(appointment?.time)}
						</Button>
						<Button size="M" variant="secondaryDefault" data-testid="button_see_all_times" href={`${siteUrl}/book-an-appointment/?fc=${officeInfo.code}&visitReason=${type}`}>
							See all available times
						</Button>
					</> : <Button size="M" variant="primaryDefault" data-testid="button_schedule_today" href={`${siteUrl}/book-an-appointment/?fc=${officeInfo?.code}&visitReason=${type}`}>
						Schedule Now
					</Button>}
			</Box>
		</Box>;
};
export default AccordionPAO;